import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserModuleAnswerOutput } from 'infrastructure/graphql/content/user/model/user-module-answer.output';
import { UserModuleAnswer } from 'user/user-module-answer';
import { UserModuleAnswerTask } from 'user/user-module-answer-task';

@Injectable({ providedIn: 'root' })
export class UserModuleAnswerConverterService {
	public userModuleAnswerAsEntity(
		output: UserModuleAnswerOutput
	): UserModuleAnswer {
		if (!output) {
			return null;
		}

		return new UserModuleAnswer(
			output.id,
			output.value,
			output.userId,
			output.pageId,
			output.moduleId,
			output.contactId,
			output.article?.id,
			output.document ? output.document.id : null,
			output.question ? output.question.id : null,
			output.orgModuleId,
			output.question ? output.question.name : null,
			output.reportTaskId,
			output.updateTimestamp,
			output.reportJobOfferId,
			output.type,
			output.task
				? new UserModuleAnswerTask(
						output.task.id,
						output.task.label,
						new Date(output.task.dueTimestamp),
						output.task.userTaskId
				  )
				: null
		);
	}

	public userModuleAnswersAsEntities(
		outputs: UserModuleAnswerOutput[]
	): UserModuleAnswer[] {
		return reject(outputs, isNil).map((output) =>
			this.userModuleAnswerAsEntity(output)
		);
	}
}
